<button
    mat-icon-button
    (click)="openPanel()"
    #notificationsOrigin>
    <ng-container *ngIf="unreadCount > 0">
        <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
            <span class="flex items-center justify-center flex-shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-teal-600 text-indigo-50 text-xs font-medium">
                {{unreadCount}}
            </span>
        </span>
    </ng-container>
    <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<ng-template #notificationsPanel>
    <div class="notifications-panel min-w-80 sm:min-w-96 max-w-96 max-h-screen sm:max-h-120 overflow-hidden">
        <!-- Header -->
        <div class="flex items-center justify-between px-4 pt-4 pb-2 border-b">
            <div class="text-lg font-medium">Notifications</div>
            <!-- <button
                class="ml-2"
                mat-flat-button
                [color]="'primary'"
                [disabled]="unreadCount === 0"
                (click)="markAllAsRead()">
                Mark all as read
            </button> -->
        </div>

        <!-- Notifications list -->
        <div class="notifications-list">
            <cdk-virtual-scroll-viewport itemSize="74" minBufferPx="390" maxBufferPx="520" class="h-96" (scrolledIndexChange)="onScroll()">
                <ng-container *ngIf="notifications.length > 0; else noNotifications">
                    <ng-container *cdkVirtualFor="let notification of notifications; trackBy: trackByFn">
                        <div
                            class="notification-item flex items-start p-4 cursor-pointer border-b"
                            [ngClass]="{'unread': !notification.isRead}"
                            (click)="markAsRead(notification)">
                            <div class="flex flex-0 items-center justify-center w-10 h-10 rounded-full overflow-hidden">
                                <ng-container *ngIf="notification.type === 'readyForOutward'">
                                    <mat-icon class="icon-size-6 text-blue-500" [svgIcon]="'heroicons_solid:information-circle'"></mat-icon>
                                </ng-container>
                                <ng-container *ngIf="notification.type === 2">
                                    <mat-icon class="icon-size-6 text-green-500" [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                                </ng-container>
                                <ng-container *ngIf="notification.type === 3">
                                    <mat-icon class="icon-size-6 text-amber-500" [svgIcon]="'heroicons_solid:exclamation-circle'"></mat-icon>
                                </ng-container>
                                <ng-container *ngIf="notification.type === 4">
                                    <mat-icon class="icon-size-6 text-red-500" [svgIcon]="'heroicons_solid:x-circle'"></mat-icon>
                                </ng-container>
                            </div>
                            <div class="flex-1 ml-4">
                                <div class="font-semibold line-clamp-1">{{notification.title}}</div>
                                <div class="text-secondary mt-0.5">{{notification.message}}</div>
                                <div class="text-sm text-secondary mt-1">{{ formatLocalTime(notification.createdOn)}}</div>

                            </div>
                            <!-- <button
                                class="w-8 h-8 min-h-8"
                                mat-icon-button
                                (click)="$event.stopPropagation(); delete(notification)">
                                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:x'"></mat-icon>
                            </button> -->
                        </div>
                    </ng-container>
                </ng-container>

                <!-- Loading spinner -->
                <div *ngIf="isLoading" class="flex justify-center p-4">
                    <mat-progress-spinner
                        [diameter]="32"
                        [mode]="'indeterminate'">
                    </mat-progress-spinner>
                </div>
            </cdk-virtual-scroll-viewport>

            <ng-template #noNotifications>
                <div class="flex flex-col items-center justify-center p-8">
                    <div class="text-4xl text-hint">
                        <mat-icon class="icon-size-12" [svgIcon]="'heroicons_outline:bell'"></mat-icon>
                    </div>
                    <div class="mt-4 text-secondary text-center">You don't have any notifications</div>
                </div>
            </ng-template>
        </div>
    </div>
</ng-template>
